import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { SplitScreenContext } from '../../layouts/SplitScreenLayout'
import { apiClient } from '../../services/api-client'
import { ErrorCode } from '@ivy-monorepo/shared'

export const emailConfirmationContext: SplitScreenContext = {
  id: 'email-confirmation',
  title: 'Thank you!',
  message: '',
  contentSide: 'left',
}

const EmailConfirmation = () => {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const confirmEmail = async () => {
      const token = searchParams.get('token')
      const email = searchParams.get('email')

      if (!token || !email) {
        setStatus('error')
        setMessage(
          'The link is missing required parameters. Please check your email link and try again.'
        )
        return
      }

      // setEmail(email)

      try {
        await apiClient.post('/auth/email/verify', { token, email: email })
        setStatus('success')
        setMessage(
          'Your email has been successfully confirmed. You will now be redirected to the login page. Once there, please login with your new password.'
        )
        setTimeout(() => {
          navigate(`/login?email=${encodeURIComponent(email!)}`)
        }, 4000)
      } catch (error: any) {
        setStatus('error')
        if (error.code === ErrorCode.AccountAlreadyConfirmed) {
          setStatus('success')
          setMessage('Your email has already been confirmed. You can log in to your account.')
        } else if (error.code === ErrorCode.AccountMagicUrlTokenExpired) {
          setMessage('Your confirmation link has expired. Please request a new confirmation email.')
        } else {
          setMessage(
            error.message ||
              'An error occurred while confirming your email. Please try again later.'
          )
        }
      }
    }

    confirmEmail()
  }, [searchParams, navigate])

  return (
    <div className="email-confirmation">
      {status === 'success' && <div className="success-message">{message}</div>}

      {status === 'error' && (
        <>
          <div className="error-message">{message}</div>
        </>
      )}
    </div>
  )
}

export default EmailConfirmation
